import { render } from "./VendorCarsIndexButtonAdd.vue?vue&type=template&id=891eec18"
import script from "./VendorCarsIndexButtonAdd.vue?vue&type=script&lang=js"
export * from "./VendorCarsIndexButtonAdd.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__